import { store } from "@/store/store";

export const isAuth = function() {
  return localStorage.getItem("token") && store.getters.loggedUser
    ? true
    : false;
};

export const isAuthApi = function() {
  return;
};

export default {
  methods: {
    isAuth,
    isAuthApi
  }
};
